import { AlertTriangle, Home, RefreshCw, SearchX } from 'lucide-react';
import './PageState.css';

const ICONS = {
    error: AlertTriangle,
    empty: SearchX,
    fatal: AlertTriangle
};

const PageState = ({
    variant = 'error',
    title,
    message,
    actionLabel,
    onAction,
    secondaryLabel,
    onSecondaryAction,
    fullHeight = true,
    compact = false
}) => {
    const Icon = ICONS[variant] || AlertTriangle;

    return (
        <div className={`page-state-shell ${fullHeight ? 'full-height' : ''} ${compact ? 'compact' : ''}`}>
            <div className={`page-state-card ${variant}`}>
                <div className="page-state-icon">
                    <Icon size={compact ? 28 : 42} />
                </div>
                <h1>{title}</h1>
                {message && <p>{message}</p>}
                <div className="page-state-actions">
                    {onAction && actionLabel && (
                        <button className="page-state-btn primary" onClick={onAction}>
                            <RefreshCw size={16} />
                            <span>{actionLabel}</span>
                        </button>
                    )}
                    {onSecondaryAction && secondaryLabel && (
                        <button className="page-state-btn secondary" onClick={onSecondaryAction}>
                            <span>{secondaryLabel}</span>
                        </button>
                    )}
                    {!onSecondaryAction && !secondaryLabel && variant !== 'empty' && (
                        <button className="page-state-btn secondary" onClick={() => window.location.assign('/')}>
                            <Home size={16} />
                            <span>Accueil</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageState;
